<template>
  <div class="body-wrapper">
    <QuestionImage
        :attaches="questionData?.content?.attach
    ?.filter(item => item.file?.attachUrl)
    ?.map(item => ({ attachUrl: item.file.attachUrl })) || []"
    />
    <h5 class="title" v-if="questionData?.content?.type === 'welcomeText'">
      {{ $t("welcome") }}🙏🏻
    </h5>
    <h5 class="title" v-else v-html="questionData?.name">
    </h5>
    <div
        class="paragraph"
        v-if="questionData?.content?.type === 'welcomeText'"
        v-html="questionData?.name"
    ></div>

    <div
        class="paragraph"
        v-else
        v-html="questionData?.description"
    ></div>
  </div>
</template>

<script>
import QuestionImage from "@/components/QuestionImage.vue";

export default{
  components: {QuestionImage},
  props:{
    questionData: {
      type: Object,
      required: true
    }
  },
  created() {
    console.log(this.questionData.content);
    console.log(this.questionData?.content?.attach?.map(item => ({ attachUrl: item.file?.attachUrl })))
  }
}
</script>

<style scoped>
.body-wrapper {
  display: flex;
  flex-direction: column;
  gap: 3px;
  width: 100%;
  padding: 10px;
}

.title {
  font-size: 18px;
  color: #040C2D;
  margin: 0;
  padding: 0;
  font-family: euclid_semi_bold, sans-serif;
}

.paragraph {
  font-size: 14px;
  color: #475467;
  margin: 0;
  padding: 0;
  font-family: euclid_regular, sans-serif;
}

.paragraph :deep(p) {
  margin: 0;
  padding: 0;
}
</style>
